import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import FormGranularStepsPreview from "../../FormGranularStepsPreview/FormGranularStepsPreview";
import useMarking from "../../../../../../../hooks/maestro/useMarking";
import {
  updateClassMarkingStudentGranularSteps
} from "../../../../../../../store/actions/class-marking.actions";
import Loading from "../../../../../../Loading/Loading";

const LcsData = ({}) => {
  const dispatch = useDispatch();
  const { onSetMarkingGranularSteps, newLogMarking, onModeMarking } = useMarking();
  const mode = useSelector((state) => state?.classMarking?.mode || []);

  const student = useSelector((state) => state?.classMarking?.student);
  const studentLoading = useSelector(
    (state) => state?.classMarking?.studentLoading
  );
  const ulData = useSelector((state) => state?.class?.unitOfLearning || {});

  const lcsIds = useSelector((state) => state?.classMarking.lcsIds || []);
  const lcs = useSelector((state) => state?.class?.unitOfLearning?.lcs || []);
  const completed = useSelector((state) => state?.classMarking.completedType);
  const currentMode = mode?.find((item) => item.studentId === student?._id);

  const onSetMarking = (lcId, granularSteps = [], maxLevel) => {
    const logMarking =
      completed === "completedTeacher"
        ? student.logMarkingTeacher || []
        : completed === "completedStudent"
        ? student.logMarkingStudent || []
        : [];

    const gs = onSetMarkingGranularSteps(granularSteps, completed, maxLevel);
    const newLog = newLogMarking(
      student._id,
      lcId,
      granularSteps,
      gs,
      completed
    );

    if (newLog.from.length > 0) {
      logMarking.unshift(newLog);
    }
    dispatch(updateClassMarkingStudentGranularSteps(lcId, completed, gs, logMarking));
    onModeMarking(student, logMarking);
  };

  const renderLcs = useCallback(
    (lcs) => {
      return lcs.filter((lc) =>
        lcsIds.length > 0 ? lcsIds.includes(lc._id) : true
      );
    },
    [lcsIds]
  );

  const permission = useSelector(
    (state) => state?.session?.permissions?.["marking-class"] || {}
  );

  const checkPermission = () => {

    if (completed === "completedTeacher" && permission?.["by-teacher"]) {
      return true;
    }
    if (completed === "completedStudent" && permission?.["by-student"]) {
      return true;
    }

    return false;
  };

  return (
    <>
      {(studentLoading || currentMode?.mode === 'saving') && (
        <div className="absolute top-0 bottom-0 left-200px right-0 bg-loading z-12">
          <Loading />
        </div>
      )}
      <div
        className={[
          "absolute top-0 bottom-0 left-200px right-0 overflow-auto",
          student ? "" : "opacity-90 cursor-not-allowed pointer-events-none",
        ].join(" ")}
      >
        <FormGranularStepsPreview
          lcs={renderLcs(student ? student.lcs : lcs)}
          onSetMarking={
            student && ulData.status === "active" && checkPermission()
              ? onSetMarking
              : undefined
          }
          completed={completed}
        />
      </div>
    </>
  );
};

export default LcsData;
